/**
 * Uango Cross-sell Popup
 * カート追加時に関連商品をレコメンドするポップアップ
 *
 * ルール：
 *   お味噌玉キット追加 → sogika（14日間）をレコメンド
 *   sogika（14日間 or 7日間）追加 → お味噌玉キットをレコメンド
 */
(function () {
  'use strict';

  /* ─────────────────────────────────────────
     クロスセル定義テーブル
     key: 追加されたバリアントID（文字列）
     value: レコメンドする商品情報
  ───────────────────────────────────────── */
  const CROSS_SELL_MAP = {
    // お味噌玉キット（通常だし）→ sogika 14日間
    '49929453666580': {
      variantId : '51382993486100',
      brand     : 'sogika',
      name      : '罪悪感フリーのおやつキット\n（14日間）',
      price     : '¥4,540',
      desc      : '厳選素材のおやつを14日分。甘いものを我慢しなくていい。',
      image     : 'https://cdn.shopify.com/s/files/1/0751/1366/0692/files/sogika14_1_new.png',
      label     : '🛒 一緒によく買われています',
    },
    // お味噌玉キット（精進だし）→ sogika 14日間
    '49929453699348': {
      variantId : '51382993486100',
      brand     : 'sogika',
      name      : '罪悪感フリーのおやつキット\n（14日間）',
      price     : '¥4,540',
      desc      : '厳選素材のおやつを14日分。甘いものを我慢しなくていい。',
      image     : 'https://cdn.shopify.com/s/files/1/0751/1366/0692/files/sogika14_1_new.png',
      label     : '🛒 一緒によく買われています',
    },
    // sogika 14日間 → お味噌玉キット（通常だし）
    '51382993486100': {
      variantId : '49929453666580',
      brand     : 'UANGO',
      name      : 'お味噌玉に！乾燥具材キット\n（だし粉末付）',
      price     : '¥2,180',
      desc      : '毎日のお味噌汁がもっと簡単に。UANGOオリジナルの具材ミックス。',
      image     : 'https://cdn.shopify.com/s/files/1/0751/1366/0692/files/uango-catalog-11.jpg?v=1738227820',
      label     : '🍱 一緒に買う人が多いです',
    },
    // sogika 7日間 → お味噌玉キット（通常だし）
    '51234189934868': {
      variantId : '49929453666580',
      brand     : 'UANGO',
      name      : 'お味噌玉に！乾燥具材キット\n（だし粉末付）',
      price     : '¥2,180',
      desc      : '毎日のお味噌汁がもっと簡単に。UANGOオリジナルの具材ミックス。',
      image     : 'https://cdn.shopify.com/s/files/1/0751/1366/0692/files/uango-catalog-11.jpg?v=1738227820',
      label     : '🍱 一緒に買う人が多いです',
    },
  };

  let popup    = null;
  let addBtn   = null;
  let btnText  = null;
  let isAdding = false;

  // セッション中に追加済みのバリアントIDを記録（同じ組み合わせを二度出さない）
  const addedSet = new Set();

  /* ─────────────────────────────────────────
     初期化
  ───────────────────────────────────────── */
  function init() {
    popup   = document.getElementById('uango-crosssell-popup');
    if (!popup) return;

    addBtn  = popup.querySelector('.uango-cs-add-btn');
    btnText = popup.querySelector('.uango-cs-btn-text');

    popup.querySelector('.uango-cs-overlay').addEventListener('click', closePopup);
    popup.querySelector('.uango-cs-close').addEventListener('click', closePopup);
    popup.querySelector('.uango-cs-skip').addEventListener('click', closePopup);
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && popup.classList.contains('is-open')) closePopup();
    });

    addBtn.addEventListener('click', addRecommendToCart);

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, onCartUpdate);
    }
  }

  /* ─────────────────────────────────────────
     カート更新イベントハンドラ
  ───────────────────────────────────────── */
  function onCartUpdate(event) {
    if (event.source !== 'product-form') return;

    const triggerId = String(event.productVariantId);
    const rec = CROSS_SELL_MAP[triggerId];
    if (!rec) return;

    // レコメンド商品がすでにカートに追加済みならスキップ
    if (addedSet.has(rec.variantId)) return;

    // デフォルトのカート通知を一時的に抑制
    suppressDefaultCartNotification();

    // ポップアップ内容を今回のレコメンドで更新してから表示
    setTimeout(() => {
      populatePopup(rec);
      openPopup();
    }, 100);
  }

  /* ─────────────────────────────────────────
     デフォルトカート通知を一時的に抑制
  ───────────────────────────────────────── */
  function suppressDefaultCartNotification() {
    const cartEl = document.querySelector('cart-notification') ||
                   document.querySelector('cart-drawer');
    if (!cartEl || typeof cartEl.open !== 'function') return;

    const originalOpen  = cartEl.open.bind(cartEl);
    cartEl.open = function () { /* suppressed */ };
    setTimeout(() => { cartEl.open = originalOpen; }, 3000);
  }

  /* ─────────────────────────────────────────
     ポップアップ内容をレコメンド商品で更新
  ───────────────────────────────────────── */
  function populatePopup(rec) {
    popup.querySelector('.uango-cs-label').innerHTML =
      `<span class="uango-cs-label-icon">${rec.label.slice(0, 2)}</span>${rec.label.slice(2)}`;
    popup.querySelector('.uango-cs-img').src = rec.image;
    popup.querySelector('.uango-cs-img').alt = rec.name.replace('\n', '');
    popup.querySelector('.uango-cs-brand').textContent = rec.brand;
    popup.querySelector('.uango-cs-name').innerHTML = rec.name.replace('\n', '<br>');
    popup.querySelector('.uango-cs-price').textContent = rec.price;
    popup.querySelector('.uango-cs-desc').textContent = rec.desc;

    // 追加ボタンをリセット
    addBtn.classList.remove('loading', 'added');
    addBtn.removeAttribute('aria-disabled');
    btnText.textContent = 'カートに追加する';

    // 今回のレコメンド商品のバリアントIDをボタンに紐づけ
    addBtn.dataset.variantId = rec.variantId;
  }

  /* ─────────────────────────────────────────
     ポップアップ開閉
  ───────────────────────────────────────── */
  function openPopup() {
    popup.classList.add('is-open');
    popup.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    setTimeout(() => addBtn && addBtn.focus(), 50);
  }

  function closePopup() {
    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  /* ─────────────────────────────────────────
     レコメンド商品をカートに追加
  ───────────────────────────────────────── */
  async function addRecommendToCart() {
    if (isAdding) return;
    const variantId = addBtn.dataset.variantId;
    if (!variantId) return;

    isAdding = true;
    addBtn.classList.add('loading');
    addBtn.setAttribute('aria-disabled', 'true');

    try {
      const res = await fetch('/cart/add.js', {
        method : 'POST',
        headers: { 'Content-Type': 'application/json' },
        body   : JSON.stringify({ id: variantId, quantity: 1 }),
      });

      if (!res.ok) throw new Error('add failed');

      addedSet.add(variantId);
      addBtn.classList.remove('loading');
      addBtn.classList.add('added');
      btnText.textContent = '✓ 追加しました！';

      refreshCartBubble();
      setTimeout(closePopup, 1300);

    } catch (err) {
      addBtn.classList.remove('loading');
      addBtn.removeAttribute('aria-disabled');
      btnText.textContent = 'カートに追加する';
      console.error('[uango-crosssell] add error:', err);
    } finally {
      isAdding = false;
    }
  }

  /* ─────────────────────────────────────────
     カートアイコンバッジ更新
  ───────────────────────────────────────── */
  function refreshCartBubble() {
    fetch(`${window.location.pathname}?sections=cart-icon-bubble`)
      .then((r) => r.json())
      .then((data) => {
        const el  = document.getElementById('cart-icon-bubble');
        const html = data['cart-icon-bubble'];
        if (!el || !html) return;
        el.innerHTML = new DOMParser()
          .parseFromString(html, 'text/html')
          .querySelector('.shopify-section')?.innerHTML || '';
      })
      .catch(() => {});
  }

  /* ─────────────────────────────────────────
     DOM 準備後に初期化
  ───────────────────────────────────────── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
